<template>
  <div class="container">
    <slot />
  </div>
</template>

<style scoped>
.container {
  padding: 0 var(--gap-sm);
  display: flex;
  column-gap: var(--gap-md);
  flex-direction: row-reverse;
}
</style>
